import { render, staticRenderFns } from "./solvingQuiz.vue?vue&type=template&id=1bd636cf"
import script from "./solvingQuiz.vue?vue&type=script&lang=js"
export * from "./solvingQuiz.vue?vue&type=script&lang=js"
import style0 from "./solvingQuiz.vue?vue&type=style&index=0&id=1bd636cf&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bd636cf')) {
      api.createRecord('1bd636cf', component.options)
    } else {
      api.reload('1bd636cf', component.options)
    }
    module.hot.accept("./solvingQuiz.vue?vue&type=template&id=1bd636cf", function () {
      api.rerender('1bd636cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/edu/quiz/solvingQuiz.vue"
export default component.exports